import { upperFirst } from 'lodash';

export default function getServiceDataKey(action) {
  return `intShop${upperFirst(action)}`;
}
